import { XCircle } from 'lucide-react';

const Modal = ({ title, onClose, containerRef, children }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-20">
      <div ref={containerRef} className="bg-white rounded-lg p-8 max-w-2xl w-full relative overflow-auto h-4/6">
        <h2 className="text-2xl mb-4">{title}</h2>
        {children}
        <button onClick={onClose} className="modal-close-btn absolute top-4 right-4 text-neutral-700 hover:text-danger-outlined-Color">
          <XCircle size={24} />
        </button>
      </div>
    </div>
  );
};

export { Modal };